/**
 * PDP size-line chips: navigate to sibling SKU URL (full page).
 * Markup: [data-pdp-line] > … > li[data-id][data-url][data-available]
 *
 * @param {ParentNode} [root=document]
 */
export function initPdpLine(root = document) {
  const blocks = root.querySelectorAll('[data-pdp-line]');

  blocks.forEach((block) => {
    if (!(block instanceof HTMLElement) || block.dataset.pdpLineInited === '1') {
      return;
    }
    block.dataset.pdpLineInited = '1';

    block.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        return;
      }

      const item = target.closest('[data-id][data-url]');
      if (!(item instanceof HTMLElement) || !block.contains(item)) {
        return;
      }

      if (item.getAttribute('data-available') === '0') {
        return;
      }

      const url = item.getAttribute('data-url') || '';
      const id = item.getAttribute('data-id') || '';
      if (!url || id === block.dataset.activeId) {
        return;
      }

      window.location.href = url;
    });
  });
}
